import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2, User, Lock, Factory } from 'lucide-react'
import toast from 'react-hot-toast'
import { useAuth } from '@/lib/auth'

export default function MobileLoginPage() {
  const nav = useNavigate()
  const { login, token } = useAuth()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [loading, setLoading] = useState(false)

  // Se já tá logado, manda direto pro operador
  useEffect(() => {
    if (token) nav('/m/operador', { replace: true })
  }, [token])

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!email || !senha) return
    setLoading(true)
    try {
      await login(email, senha)
      nav('/m/operador', { replace: true })
    } catch (e: any) {
      toast.error(e?.response?.data?.detail || 'Login inválido')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-violet-700 via-blue-700 to-blue-900 text-white px-6 py-10">
      <div className="flex-1 flex flex-col items-center justify-center max-w-md mx-auto w-full">
        <div className="w-20 h-20 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center mb-4 shadow-xl">
          <Factory className="h-10 w-10 text-white" />
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight">VELORE ERP<span className="text-emerald-300">·</span>OP</h1>
        <p className="text-white/70 text-sm mt-1 mb-8">Apontamento de Produção</p>

        <form onSubmit={submit} className="w-full space-y-4">
          <div>
            <label className="text-xs uppercase opacity-80 font-bold ml-1">Usuário</label>
            <div className="relative mt-1">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-white/50" />
              <input
                type="text" inputMode="email" autoComplete="username"
                value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="seu.email@empresa"
                className="w-full h-14 pl-11 pr-4 bg-white/15 backdrop-blur border-2 border-white/20 focus:border-emerald-300 focus:outline-none rounded-2xl text-white placeholder-white/40 text-base"
                autoFocus
              />
            </div>
          </div>

          <div>
            <label className="text-xs uppercase opacity-80 font-bold ml-1">Senha</label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-white/50" />
              <input
                type="password" autoComplete="current-password"
                value={senha} onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••"
                className="w-full h-14 pl-11 pr-4 bg-white/15 backdrop-blur border-2 border-white/20 focus:border-emerald-300 focus:outline-none rounded-2xl text-white placeholder-white/40 text-base"
              />
            </div>
          </div>

          <button
            type="submit" disabled={loading || !email || !senha}
            className="w-full h-16 mt-6 bg-emerald-500 hover:bg-emerald-600 active:bg-emerald-700 text-white font-extrabold text-lg rounded-2xl flex items-center justify-center gap-2 shadow-xl shadow-emerald-500/30 disabled:opacity-40 disabled:shadow-none transition"
          >
            {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : 'Entrar'}
          </button>
        </form>
      </div>

      <div className="text-center text-xs text-white/40 pt-4">
        v1.0 · uso restrito ao chão de fábrica
      </div>
    </div>
  )
}
